<template>
  <svg
    id="functions"
    :x="svgCoords.x"
    :y="svgCoords.y"
    width="400"
    height="320"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 317.3 253.5"
    role="presentation"
    aria-labelledby="launchoffunctions"
  >
    <title id="launchoffunctions">Launch of Netlify Functions</title>
    <defs>
      <clipPath id="clip-path" transform="translate(-0.9 -1)">
        <rect class="cls-1" x="12" y="152" width="27" height="28" />
      </clipPath>
      <clipPath id="clip-path-2" transform="translate(-0.9 -1)">
        <rect class="cls-1" x="70.3" y="203.3" width="28.4" height="24.14" />
      </clipPath>
    </defs>
    <path
      class="cls-2"
      d="M215.4,159.4l-30.6,17.8,1.1.7,30.8-17.8Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M176.2,171.4c.2.4.3.7.7.9l30.6-17.6-1.2-.5Z"
      transform="translate(-0.9 -1)"
    />
    <path class="cls-2" d="M178.6,173.5l1.3.7,30.6-17.6-1-.7Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M181.8,175.5l1.1.5,30.6-17.6-1-.7Z" transform="translate(-0.9 -1)" />
    <path
      class="cls-2"
      d="M204.2,188.3c.2,0,.2.2.3.2l30-17.3c-.2-.3-.4-.7-.6-.8L213,182.5l-.4-.2-60.7,35.1h.2l.8.6Z"
      transform="translate(-0.9 -1)"
    />
    <path class="cls-2" d="M216.7,184.6l-1.1-.7-60.9,35.2,1.1.7Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M219.8,186.4l-1-.5-60.7,35v.2l.7.5Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M222.8,188.1l-1-.5-60.9,35,1,.7Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M226,189.9l-1-.5-61,35.2,1.1.5Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M229,191.8l-1.1-.7L167,226.3l1.1.6Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M232.2,193.6l-1.1-.7-60.9,35.2.2.2.9.5Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M235.2,195.4l-1.1-.7-60.9,35.2,1,.7Z" transform="translate(-0.9 -1)" />
    <path class="cls-2" d="M238.3,197.1l-1-.5-60.8,35,.2.2.7.5Z" transform="translate(-0.9 -1)" />
    <path
      class="cls-2"
      d="M241.5,198.9l-1.2-.6-60.8,35.1v.2l1.1.5Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M243.6,201.3c-.2-.3-.3-.7-.5-.8l-60.4,34.8.2.2a1.9,1.9,0,0,0,1,.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M244.1,203.3l-57.2,33.1h2.3L244,204.9A7.6,7.6,0,0,1,244.1,203.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M188.5,179.3l.4.2,30.6-17.8-1.1-.7-22.3,13.1h-.7l-56.2,32.3c0,.4-.2.9,0,1.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M191.7,181.3h.3l30.7-17.7-1.1-.7-21.1,12.1-.4-.2L139.9,210l.7.8Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M143.4,212.6,194.7,183l.3.2,30.8-17.8-1.2-.5-21,12.1h-.3l-60.9,35Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M197.8,184.8l.4.2,30.6-17.6-1-.7-21,12.1-.3-.2-60.9,35.2,1,.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-2"
      d="M200.8,186.6l.4.3,30.6-17.8-1-.7-21,12.2-.3-.2-61,35.2,1.1.5Z"
      transform="translate(-0.9 -1)"
    />
    <g class="sheet" id="sheet4">
      <path
        class="cls-3"
        d="M138.2,123.5,53.1,173.7l-1-.5V111.1l86.1-49.7.9.5Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M139.3,124,53.1,173.7V111.6l86.2-49.7Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M61.2,118.4l-2.4,1.4v-2l2.4-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M96.2,98.2,63.9,116.8v-1.9L96.2,96.2Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,123l-2.4,1.4v-2l2.4-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M78.8,112.8l-14.9,8.7v-2l14.9-8.6Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,127.5,58.8,129v-1.9l2.4-1.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M86.5,113,63.9,126.1v-2L86.5,111Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,132.2l-2.4,1.4v-1.9l2.4-1.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M90.9,115l-27,15.7v-2.1l27-15.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,138.8l-2.4,1.5v-1.9l2.4-1.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M81,127.4l-17.1,10v-2.1L81,125.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,143.5l-2.4,1.3v-1.9l2.4-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M95.4,123.8,63.9,141.9v-2l31.5-18.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,148.1l-2.4,1.3v-1.9l2.4-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M76.3,139.3l-12.4,7.2v-1.9l12.4-7.2Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M61.2,152.7,58.8,154v-1.9l2.4-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M86,138.4,63.9,151.1v-1.9L86,136.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,88.5l1.8-1.1V86l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M128.8,77.5,116,84.8v1.5l12.8-7.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,92l1.8-1V89.5l-1.8,1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M121.9,84.9,116,88.3v1.4l5.9-3.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,95.6l1.8-1.1V93l-1.8,1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M124.9,86.7,116,91.8v1.5l8.9-5.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,99l1.8-1V96.4l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M126.7,89.1,116,95.3v1.5l10.7-6.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,104.1l1.8-1v-1.6l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M124.3,95.6l-8.3,4.8v1.5l8.3-4.7Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,107.6l1.8-1.1v-1.4l-1.8,1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M116,103.8v1.6l15.2-8.7V95.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,111.1,114,110v-1.4l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M122,104l-6,3.4v1.5l6-3.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M112.2,114.7l1.8-1.1v-1.5l-1.8,1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M116,112.3l10.7-6v-1.6L116,110.9Z" transform="translate(-0.9 -1)" />
    </g>
    <g class="sheet" id="sheet2">
      <path
        class="cls-3"
        d="M184.5,122.2l-85,50.2-1.1-.5V109.8l86.1-49.7,1.1.5Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M185.6,122.8,99.5,172.5V110.3l86.1-49.6Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-4"
        d="M169.6,115.9l-54.2,31.2V118.2l54.2-31.4Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M165.3,96.3l-45.5,26.3v-1.3l45.5-26.2Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M165.3,100.7l-45.5,26.2v-1.2l45.5-26.2Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M165.3,105.1l-45.5,26.2v-1.2l45.5-26.3Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M185.6,66.6,99.5,116.4v-6.1l86.1-49.6Z"
        transform="translate(-0.9 -1)"
      />
    </g>
    <g class="bloop" id="bloop2">
      <g>
        <path
          class="cls-3"
          d="M199.7,36.1a10.8,10.8,0,0,0-1.6,5.3V70.3c0,3.4,6.9,8.1,9.8,6.4l23-16.6a11.3,11.3,0,0,0,3.8-4C223.9,49.9,211.1,41.4,199.7,36.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M230.9,60.1l-23,16.6c-2.9,1.7-9.8-3-9.8-6.4V41.4a12,12,0,0,1,5.3-9.3l25.1-14.4c2.9-1.7,10.2,1.8,10.3,4.7l-2.5,28.4A11.6,11.6,0,0,1,230.9,60.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M199.7,36.1a10.8,10.8,0,0,0-1.6,5.3V70.3c0,3.4,6.9,8.1,9.8,6.4l23-16.6a11.3,11.3,0,0,0,3.8-4C223.9,49.9,211.1,41.4,199.7,36.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M199.7,36.1a10.8,10.8,0,0,0-1.6,5.3V70.3c0,3.4,6.9,8.1,9.8,6.4l23-16.6a11.3,11.3,0,0,0,3.8-4C223.9,49.9,211.1,41.4,199.7,36.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-4"
          d="M233.7,62l-25,14.5c-3,1.7-5.4.4-5.4-3v-29a11.6,11.6,0,0,1,5.4-9.2l25-14.5c2.9-1.7,5.4-.3,5.4,3.1V52.8A11.9,11.9,0,0,1,233.7,62Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M216.6,45.6l1.1,1.4-5.3,6.5,7.3.7L218.6,57l-8.4-1.2v-2Zm2.5,13.3h-1.9l7.3-21.6,1.9-.2Zm6-20,8.7,1.2v2.1l-6.3,8.2L226.3,49l5.2-6.5-7.6-.8Z"
          transform="translate(-0.9 -1)"
        />
      </g>
      <g>
        <path
          class="cls-3"
          d="M69,83.3,46,99.9c-2.9,1.8-9.8-3-9.8-6.4V64.6a12,12,0,0,1,5.3-9.3L66.6,40.9c2.9-1.7,10.2,1.8,10.3,4.7L74.4,74.1A12.5,12.5,0,0,1,69,83.3Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M37.6,59.4a11.4,11.4,0,0,0-1.5,5.2V93.5c0,3.4,6.9,8.2,9.8,6.4l23-16.6a11,11,0,0,0,3.7-4C62,73.1,49.1,64.5,37.6,59.4Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M37.6,59.4a11.4,11.4,0,0,0-1.5,5.2V93.5c0,3.4,6.9,8.2,9.8,6.4l23-16.6a11,11,0,0,0,3.7-4C62,73.1,49.1,64.5,37.6,59.4Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M37.6,59.4a11.4,11.4,0,0,0-1.5,5.2V93.5c0,3.4,6.9,8.2,9.8,6.4l23-16.6a11,11,0,0,0,3.7-4C62,73.1,49.1,64.5,37.6,59.4Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-4"
          d="M71.8,85.1,46.6,99.6c-2.9,1.7-5.3.3-5.3-3.1V67.6a11.8,11.8,0,0,1,5.3-9.2L71.7,43.9c2.9-1.7,5.3-.3,5.3,3.1V75.9A11.7,11.7,0,0,1,71.8,85.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M48.9,73.5v1.2l-.4.3a.3.3,0,0,0-.3.3c-.1.1-.1.2-.1.5v1.4a4.1,4.1,0,0,1-.1,1.1,1.6,1.6,0,0,1-.5.9l-.8.7.8-.2a.6.6,0,0,1,.5.2,2.5,2.5,0,0,1,.1,1v1.7c0,.2,0,.3.1.3s.1.2.4,0l.5-.2v1.2l-1.1.5h-.8c-.1,0-.2-.2-.3-.4a1.1,1.1,0,0,1,0-.8V81.7c0-.2,0-.5-.1-.6h-.5a.9.9,0,0,0-.7.4V79.9l.7-.5a1.5,1.5,0,0,0,.5-.6,1.7,1.7,0,0,0,.1-.7V75.6l.3-.8a1.9,1.9,0,0,1,.8-.7Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M55.3,77.8a1.7,1.7,0,0,1,.1-.7c.1-.2.2-.5.4-.6a1.1,1.1,0,0,1,.4-.5h.5l.4.2a.7.7,0,0,1,.1.5,1.5,1.5,0,0,1-.1.7,1.5,1.5,0,0,1-.4.6.8.8,0,0,1-.5.5l-.4.2c-.2,0-.3-.2-.4-.3S55.3,77.9,55.3,77.8Zm3.6-2.2a2,2,0,0,1,.1-.7,6.1,6.1,0,0,0,.4-.6l.5-.5h.5l.3.2a.6.6,0,0,1,.2.5,1.2,1.2,0,0,1-.2.8l-.3.6c-.1.2-.4.3-.5.4l-.5.2-.4-.3C58.9,76,58.9,75.9,58.9,75.6Zm3.8-2.1a2.2,2.2,0,0,1,.1-.8c.1-.2.2-.5.4-.6l.5-.5h.4l.4.2a.9.9,0,0,1,.1.5,2.2,2.2,0,0,1-.1.8c-.1.2-.2.5-.4.6l-.4.5h-.5c-.2,0-.3-.1-.4-.3S62.7,73.7,62.7,73.5Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M70.1,61.3l1.1-.5h.7c.1,0,.3.2.4.4a1.1,1.1,0,0,1,0,.8v1.6c0,.2,0,.5.1.6h.5a.9.9,0,0,0,.7-.4v1.5l-.7.5c-.3.1-.4.4-.5.6a1.7,1.7,0,0,0-.1.7v2.5l-.4.8a1.2,1.2,0,0,1-.7.7l-1.1.8V70.7l.5-.4a.8.8,0,0,0,.2-.4c.1-.1.1-.2.1-.5V68a4.1,4.1,0,0,1,.1-1.1l.5-.9.9-.7-.9.3c-.2,0-.3-.2-.5-.3a2.5,2.5,0,0,1-.1-1V62.6c0-.2,0-.3-.1-.3s-.1-.2-.2,0l-.5.2Z"
          transform="translate(-0.9 -1)"
        />
      </g>
      <g>
        <path
          class="cls-3"
          d="M153.7,44.4,130.9,61.1C128,62.8,121,58,121,54.6V25.7a12.1,12.1,0,0,1,5.4-9.3L151.4,2c2.9-1.7,10.2,1.8,10.3,4.7l-2.5,28.5A11.8,11.8,0,0,1,153.7,44.4Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M122.5,20.5a10.5,10.5,0,0,0-1.6,5.2V54.6c0,3.4,6.9,8.2,9.9,6.5l22.9-16.7a10.5,10.5,0,0,0,3.8-4C146.8,34.2,133.9,25.6,122.5,20.5Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M122.5,20.5a10.5,10.5,0,0,0-1.6,5.2V54.6c0,3.4,6.9,8.2,9.9,6.5l22.9-16.7a10.5,10.5,0,0,0,3.8-4C146.8,34.2,133.9,25.6,122.5,20.5Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-4"
          d="M156.6,46.2l-25,14.5c-2.9,1.7-5.3.4-5.3-3v-29a11.8,11.8,0,0,1,5.3-9.2L156.6,5c3-1.7,5.4-.3,5.4,3.1V37A11.9,11.9,0,0,1,156.6,46.2Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M144.6,25.9v8.3a16.4,16.4,0,0,1-.2,2.2,12.1,12.1,0,0,1-.9,2,8.5,8.5,0,0,1-1.4,1.9,8.1,8.1,0,0,1-2,1.4,4.5,4.5,0,0,1-1.8.8,3.8,3.8,0,0,1-1.5,0l1-2.5a2.1,2.1,0,0,0,1.1,0,2.7,2.7,0,0,0,1.1-.5,3.2,3.2,0,0,0,1.4-1.4,4.5,4.5,0,0,0,.7-2.3V29.7l-3.4,1.9V29.5Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M155.8,28.6a6.5,6.5,0,0,1-.6,2.4,7.3,7.3,0,0,1-1.6,2.3,11.6,11.6,0,0,1-2.4,2,6.5,6.5,0,0,1-2.7,1,2.7,2.7,0,0,1-1.8-.4l1.3-2.6a2,2,0,0,0,1.3.2l1.7-.6a4.4,4.4,0,0,0,1-.8,1.8,1.8,0,0,0,.6-.9,2.2,2.2,0,0,0,.3-1c0-.4-.1-.6-.3-.7a.6.6,0,0,0-.6-.3h-1.2a5.9,5.9,0,0,1-2.1.3,2.7,2.7,0,0,1-1.2-.6,3.3,3.3,0,0,1-.3-1.5,4.6,4.6,0,0,1,.6-2.3,7.2,7.2,0,0,1,1.5-2.2l2.1-1.7a4.9,4.9,0,0,1,2.3-.8,2.5,2.5,0,0,1,1.7.2l-1.2,2.4A2.4,2.4,0,0,0,153,23l-1.3.5-.9.6-.6.7a2.4,2.4,0,0,0-.2.9,1.1,1.1,0,0,0,.2.6h.7l1.4-.2a4,4,0,0,1,1.8-.2c.5,0,.8.3,1.2.7A3.2,3.2,0,0,1,155.8,28.6Z"
          transform="translate(-0.9 -1)"
        />
      </g>
      <g>
        <path
          class="cls-3"
          d="M3,153.2a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.9,6.5l22.9-16.7a10.5,10.5,0,0,0,3.8-4C27.2,166.9,14.4,158.4,3,153.2Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M34.2,177.1,11.3,193.8c-3,1.7-9.9-3.1-9.9-6.5V158.4a11.9,11.9,0,0,1,5.4-9.2l25-14.5c2.9-1.7,10.2,1.8,10.3,4.8l-2.5,28.4A11.6,11.6,0,0,1,34.2,177.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M3,153.2a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.9,6.5l22.9-16.7a10.5,10.5,0,0,0,3.8-4C27.2,166.9,14.4,158.4,3,153.2Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M3,153.2a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.9,6.5l22.9-16.7a10.5,10.5,0,0,0,3.8-4C27.2,166.9,14.4,158.4,3,153.2Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-4"
          d="M37,179.1,12,193.5c-2.9,1.7-5.4.4-5.4-3V161.6a12.1,12.1,0,0,1,5.4-9.3l25-14.4c3-1.7,5.4-.4,5.4,3v28.9A11.8,11.8,0,0,1,37,179.1Z"
          transform="translate(-0.9 -1)"
        />
        <g class="cls-5">
          <path
            d="M16.6,172.6l1.5-5.3,1.6,3.6Zm3.1-9.6-3,1.7L12,180l3-1.7.7-2.7,4.8-2.7.8,1.8,3.1-1.7Z"
            transform="translate(-0.9 -1)"
          />
          <path
            d="M28.2,164.6v-3.8l1.9-1.1a1.7,1.7,0,0,1,1.3-.3c.4.1.5.6.5,1.2a3.4,3.4,0,0,1-.5,1.7,5.3,5.3,0,0,1-1.3,1.3Zm2-7.6-4.9,2.8v12.5l2.8-1.6v-3.5l2-1.1a9.9,9.9,0,0,0,3.3-3.1,7.7,7.7,0,0,0,1.1-4.1c0-1.4-.3-2.3-1.2-2.6S31.6,156.2,30.2,157Z"
            transform="translate(-0.9 -1)"
          />
          <path d="M39,152l-2.9,1.6v12.7l2.9-1.7Z" transform="translate(-0.9 -1)" />
        </g>
      </g>
    </g>
    <g class="sheet" id="sheet3">
      <path
        class="cls-3"
        d="M123.2,203.9,38.1,254.1l-1.1-.6V191.4l86.2-49.8,1,.6Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M124.2,204.4,38.1,254.1V191.8l86.1-49.7Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M124.2,148.2,38.1,197.9v-6.1l86.1-49.7Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M79.5,183.7,46,203v-1.3l33.5-19.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M79.5,189.4,46,208.9v-1.4l33.5-19.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M79.5,195.2,46,214.6v-1.4l33.5-19.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M79.5,201,46,220.4v-1.3l33.5-19.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M79.5,206.8,46,226.1v-1.3l33.5-19.3Z" transform="translate(-0.9 -1)" />
      <path
        class="cls-4"
        d="M116.8,198.8,88.6,215.1V175.6l28.2-16.2Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M79.5,212.5,46,231.8v-1.3l33.5-19.3Z" transform="translate(-0.9 -1)" />
    </g>
    <path
      class="cls-6"
      d="M158,214.4v.2a1.8,1.8,0,0,0,.9,1.1l16.9,9.7a5.5,5.5,0,0,0,2.6.6h1.8l.5-.3,46.1-26.6c.3-.3.6-.4.7-.6h0l.2-.4h0v-3.8l-2.5,1.2-15.3-8.9a6,6,0,0,0-4.9,0l-34,19.7-9.7,5.6c-.9-.8-3.3-.2-3.3-.2v3.1Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-7"
      d="M237,76.9l-2.2-1.6a4.3,4.3,0,0,0-1.2-.6s-.1,0-.1-.2h-.3a2,2,0,0,0-1.6.4l-98.3,56.6a6.1,6.1,0,0,0-2.8,4.9v72a2.3,2.3,0,0,0,.9,1.8s2.8,2.2,3.5,2.2.8-2.8.8-2.8l-.2-.8,96.1-55.5a6.1,6.1,0,0,0,2.8-4.9V83.2h.3C235.9,82,237,76.9,237,76.9Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M234.4,91.3v-8h.3c1.3-1.2,2.3-6.3,2.3-6.3l-2.2-1.6a4.3,4.3,0,0,0-1.2-.6s-.1,0-.1-.2h-.3a2,2,0,0,0-1.6.4l-98.3,56.6a5.5,5.5,0,0,0-1.9,2.1l11.5,7.7,91.5-49.9C234.3,91.4,234.3,91.3,234.4,91.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-9"
      d="M234.4,91.3v-8h.3c1.3-1.2,2.3-6.3,2.3-6.3l-2.2-1.6a4.3,4.3,0,0,0-1.2-.6s-.1,0-.1-.2h-.3a2,2,0,0,0-1.6.4l-98.3,56.6a5.5,5.5,0,0,0-1.9,2.1l11.5,7.7Zm0,0C234.3,91.4,234.3,91.3,234.4,91.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-3"
      d="M227.7,196.6h0v-3.9l-2.5,1.2L209.9,185a6,6,0,0,0-4.9,0l-43.7,25.3c-.9-.8-3.3-.2-3.3-.2v3.3a1.4,1.4,0,0,0,.9,1l16.9,9.8a6,6,0,0,0,4.9,0l46.1-26.6c.3-.3.6-.4.7-.7h0A.2.2,0,0,0,227.7,196.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-3"
      d="M227.7,192.7l-2.5,1.2L209.9,185a6,6,0,0,0-4.9,0l-34,19.7,7.4,10.4v9.7a5.6,5.6,0,0,0,2.3-.6l46.1-26.6c.3-.3.6-.4.7-.7h0l.2-.3v-.4A19.3,19.3,0,0,0,227.7,192.7Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-4"
      d="M226.8,194.6l-46.1,26.7a6,6,0,0,1-4.9,0l-16.9-9.8c-1.3-.7-1.3-2,0-2.8L205,182a6,6,0,0,1,4.9,0l16.9,9.7C228.1,192.6,228.1,193.8,226.8,194.6Z"
      transform="translate(-0.9 -1)"
    />
    <path class="cls-4" d="M199.2,198.3l-12.3,7V179l12.3-7.1Z" transform="translate(-0.9 -1)" />
    <path class="cls-7" d="M186.9,205.1l-4.2-2.6V176.3l4.2,2.4Z" transform="translate(-0.9 -1)" />
    <path
      class="cls-10"
      d="M233.5,151.4l-95.8,55.3V137.5l95.8-55.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M156.9,161.1l-2-5.7a1,1,0,0,0,.2.6,2.5,2.5,0,0,0,.1.8,3.8,3.8,0,0,0,.1,1v4.3l-1.5.8v-8.5l2.2-1.2,1.9,5.7c0-.2-.2-.5-.2-.8s-.1-.8-.1-1.1v-4.7l1.5-.8V160Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M164.4,149.7v2l2.6-1.4v1.4l-2.6,1.5v2.2l3.1-1.8V155l-4.9,2.8v-8.5l4.9-2.8-.2,1.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M174.1,144.1V151l-1.7,1v-7l-2,1.3v-1.6l5.9-3.4v1.6Z"
      transform="translate(-0.9 -1)"
    />
    <path class="cls-8" d="M179.6,148v-8.5l1.7-1v6.9l3.2-1.8v1.7Z" transform="translate(-0.9 -1)" />
    <path
      class="cls-8"
      d="M192.6,131.9v1.5l-1.4.8v5.6l1.4-.8v1.4l-4.7,2.8v-1.4l1.4-.9v-5.6l-1.4.9v-1.5Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M198.5,130v2.2l2.5-1.5v1.5l-2.5,1.4V137l-1.7,1v-8.5l4.8-2.8v1.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M208.1,128.3v3.1l-1.7,1v-3.2l-2.5-3.8,2-1.1,1.3,2.8,1.5-4.5,1.8-1.1Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M156,169.1v2.2l2.6-1.5v1.5l-2.6,1.5v3.4l-1.7.9v-8.5l4.9-2.8v1.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M167.6,161.1v5.6a3.3,3.3,0,0,1-.4,1.7,8,8,0,0,1-.8,1.6,10,10,0,0,1-1.5,1.3,2.7,2.7,0,0,1-1.6.5,1.1,1.1,0,0,1-.8-.5,2.4,2.4,0,0,1-.3-1.5v-5.6l1.7-.9v4.8a10.8,10.8,0,0,0,.2,1.6c.1.4.3.4.8.1a2,2,0,0,0,.9-1.1,8.7,8.7,0,0,0,.1-1.8v-4.8Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M173.8,166l-2-5.8a.7.7,0,0,0,.2.6,3.1,3.1,0,0,0,.1.9,4.1,4.1,0,0,0,.1,1v4.2l-1.5.9v-8.5l2.2-1.2,1.9,5.7c0-.3-.2-.5-.2-.9s-.1-.7-.1-1.1v-4.6l1.5-.9v8.6Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M182.4,152.3l1.3-.4h1l-.8,1.7h-.6l-.9.2c-.4.1-.6.5-.8.8a3,3,0,0,0-.6,1.4,4.8,4.8,0,0,0-.3,1.8,3.5,3.5,0,0,0,.3,1.6.7.7,0,0,0,.6.6,1.2,1.2,0,0,0,.8-.2l1-.8.7-.8.9.7a4.5,4.5,0,0,1-1,1.3,6.4,6.4,0,0,1-1.5,1.3,2.4,2.4,0,0,1-1.8.4,1.3,1.3,0,0,1-1.2-.8,4.2,4.2,0,0,1-.5-2.2,6.2,6.2,0,0,1,.5-2.7,5.9,5.9,0,0,1,1.2-2.2A5.5,5.5,0,0,1,182.4,152.3Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M191.2,149.1V156l-1.7,1v-7l-2.1,1.2v-1.5l5.9-3.4v1.5Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M201.1,141.6v1.5l-1.4.9v5.5l1.4-.8v1.4l-4.7,2.8v-1.4l1.4-.9V145l-1.4.9v-1.5Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M210.1,140.7a10.7,10.7,0,0,1-.3,2.5,13.9,13.9,0,0,1-1,2.1,5.2,5.2,0,0,1-1.6,1.4,2.1,2.1,0,0,1-1.6.4c-.5-.1-.7-.5-.9-1a3.9,3.9,0,0,1-.4-2.1,7.5,7.5,0,0,1,.4-2.6,8.3,8.3,0,0,1,.9-2.1,5.2,5.2,0,0,1,1.6-1.4,2.1,2.1,0,0,1,1.6-.4c.5.1.7.5,1,1A6.9,6.9,0,0,1,210.1,140.7Zm-1.7,1.1a8.4,8.4,0,0,0-.2-2.1c-.1-.4-.5-.5-.9-.2a1.8,1.8,0,0,0-.8,1.2,11.9,11.9,0,0,0-.3,2.4,7.2,7.2,0,0,0,.3,2.1c.2.3.5.5.8.2a1.6,1.6,0,0,0,.9-1.2A15.4,15.4,0,0,0,208.4,141.8Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M216.2,141.5l-1.9-5.7a1.5,1.5,0,0,0,.1.6,3.1,3.1,0,0,0,.1.9,3.1,3.1,0,0,0,.1.9v4.3l-1.4.8v-8.5l2.1-1.2,1.9,5.7c0-.2-.1-.5-.1-.8s-.2-.7-.2-1.1v-4.6l1.5-.9v8.5Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-8"
      d="M227,132.8a3.7,3.7,0,0,1-.3,1.5l-1,1.6a6.1,6.1,0,0,1-1.6,1.2,3.8,3.8,0,0,1-1.7.7,1.6,1.6,0,0,1-1.2-.3l.8-1.6a1.5,1.5,0,0,0,.9.2,3,3,0,0,0,1.1-.4l.6-.5.5-.6a1.8,1.8,0,0,0,.1-.6c0-.3,0-.4-.1-.5h-2.6a1.1,1.1,0,0,1-.7-.3,3.8,3.8,0,0,1-.3-1,5.3,5.3,0,0,1,.4-1.6,13,13,0,0,1,1-1.5,4.7,4.7,0,0,1,1.3-1.1l1.5-.6a1.8,1.8,0,0,1,1.1.2l-.9,1.5h-.8a1.2,1.2,0,0,0-.9.4l-.6.5-.4.5a.6.6,0,0,0-.1.4c0,.2,0,.4.1.4h2.7a.8.8,0,0,1,.8.4A1.9,1.9,0,0,1,227,132.8Z"
      transform="translate(-0.9 -1)"
    />
    <path
      class="cls-3"
      d="M233.6,151.2l-95.9,55.5-.8-.5,95.8-55.4Z"
      transform="translate(-0.9 -1)"
    />
    <path class="cls-3" d="M233.7,151.4l-1-.5V81.6l1,.6Z" transform="translate(-0.9 -1)" />
    <path
      class="cls-4"
      d="M237.5,78.4c0-1.8-1.2-2.5-2.8-1.5l-98.2,56.7a6.1,6.1,0,0,0-2.8,4.9v71.9c0,1.9,1.2,2.6,2.8,1.6l98.2-56.7a6.1,6.1,0,0,0,2.8-4.9ZM137.7,206.7V137.5l95.8-55.3v69.2Z"
      transform="translate(-0.9 -1)"
    />
    <g class="sheet" id="sheet1">
      <path
        class="cls-3"
        d="M316.6,132.9l-85.1,50.2-1-.5V120.5l86.1-49.7,1,.5Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M317.7,133.4l-86.2,49.7V121l86.2-49.7Z"
        transform="translate(-0.9 -1)"
      />
      <path
        class="cls-3"
        d="M274.7,107.6l-32.4,18.6v-1.9l32.4-18.8Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M257.3,122.2l-15,8.6v-1.9l15-8.7Z" transform="translate(-0.9 -1)" />
      <path
        class="cls-3"
        d="M264.9,122.3l-22.6,13.1v-1.9l22.6-13.1Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M239.7,127.8l-2.5,1.3v-1.9l2.5-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,132.4l-2.5,1.3v-1.9l2.5-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,137l-2.5,1.4v-2l2.5-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,141.5l-2.5,1.5v-2l2.5-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,148.2l-2.5,1.5v-2l2.5-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,152.8l-2.5,1.4v-2l2.5-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,157.4l-2.5,1.4v-2l2.5-1.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M239.7,162.1l-2.5,1.3v-1.9l2.5-1.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M269.3,124.4l-27,15.7v-2l27-15.7Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M259.5,136.8l-17.2,9.9v-1.9l17.2-10Z" transform="translate(-0.9 -1)" />
      <path
        class="cls-3"
        d="M273.7,133.1l-31.4,18.1v-1.9l31.4-18.1Z"
        transform="translate(-0.9 -1)"
      />
      <path class="cls-3" d="M254.7,148.7l-12.4,7.2v-2l12.4-7.2Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M264.5,147.7l-22.2,12.8v-2l22.2-12.7Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M307.1,86.8l-12.6,7.3v1.6l12.6-7.4Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,101.4l1.8-1.1V98.9l-1.8.9Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M300.3,94.2l-5.8,3.4v1.5l5.8-3.3Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,104.9l1.8-1.1v-1.4l-1.8,1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M303.4,96.1l-8.9,5.1v1.4l8.9-5.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,108.3l1.8-.9v-1.6l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M305.1,98.5l-10.6,6.2v1.4l10.6-6Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,113.4l1.8-.9v-1.6l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M302.7,104.9l-8.2,4.9v1.5l8.2-4.8Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,117l1.8-1.1v-1.5l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M294.5,113.3v1.5l15.2-8.8v-1.6Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,120.5l1.8-1.1v-1.5l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M300.4,113.3l-5.9,3.4v1.6l5.9-3.5Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M294.5,121.7l10.7-6.1v-1.5l-10.7,6.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,124l1.8-1.1v-1.4l-1.8,1.1Z" transform="translate(-0.9 -1)" />
      <path class="cls-3" d="M290.6,97.9l1.8-1.1V95.3l-1.8,1.1Z" transform="translate(-0.9 -1)" />
    </g>
    <g class="bloop" id="bloop1">
      <g>
        <path
          class="cls-3"
          d="M92.5,227.1l-23,16.6c-2.9,1.7-9.9-3-9.9-6.4V208.4a12.1,12.1,0,0,1,5.4-9.3l25-14.4c2.9-1.7,10.2,1.8,10.4,4.7l-2.6,28.5A12.1,12.1,0,0,1,92.5,227.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-3"
          d="M61.1,203.1a10.8,10.8,0,0,0-1.6,5.3v28.9c0,3.4,7,8.1,9.9,6.4l22.9-16.6a11.3,11.3,0,0,0,3.8-4C85.4,216.9,72.6,208.4,61.1,203.1Z"
          transform="translate(-0.9 -1)"
        />
        <path
          class="cls-4"
          d="M95.3,229,70.1,243.5c-2.9,1.7-5.4.4-5.4-3v-29a11.9,11.9,0,0,1,5.4-9.2l25-14.5c3-1.7,5.4-.3,5.4,3.1v28.9A11.4,11.4,0,0,1,95.3,229Z"
          transform="translate(-0.9 -1)"
        />
        <g class="cls-11">
          <path
            d="M76.6,215.9l-1.7,1v4.7l-3.1-2.9-1.5.9v7.8l1.7-.9v-4.7l3.1,2.9,1.6-.9Z"
            transform="translate(-0.9 -1)"
          />
          <path
            d="M81.2,219.5l-1,.3c-.2-.1-.5-.2-.6-.5a1.5,1.5,0,0,1-.3-1,3.1,3.1,0,0,1,.3-1.3,4.5,4.5,0,0,1,.6-1.2,2.8,2.8,0,0,1,1-.9l.9-.2c.3,0,.5.2.7.5a1.5,1.5,0,0,1,.2,1,3.2,3.2,0,0,1-.2,1.3,4.7,4.7,0,0,1-.7,1.2Zm0-6.3a5.8,5.8,0,0,0-1.9,1.6A7.1,7.1,0,0,0,78,217a5,5,0,0,0-.5,2.3,2.4,2.4,0,0,0,.5,1.8,1.4,1.4,0,0,0,1.3.7,3.6,3.6,0,0,0,1.9-.5,9.5,9.5,0,0,0,1.9-1.6,17.1,17.1,0,0,0,1.3-2.3,6.4,6.4,0,0,0,.5-2.3,3,3,0,0,0-.5-1.8,1.8,1.8,0,0,0-1.4-.6A2.6,2.6,0,0,0,81.2,213.2Z"
            transform="translate(-0.9 -1)"
          />
          <path
            d="M87.5,215.8v-4.5l1.1-.6,1-.3a.7.7,0,0,1,.6.4,1.8,1.8,0,0,1,.3,1.1,6.9,6.9,0,0,1-.2,1.3,4.1,4.1,0,0,1-.7,1.1,1.8,1.8,0,0,1-.9.8Zm1.1-6.8-2.9,1.7v7.8l2.9-1.7a5.8,5.8,0,0,0,1.9-1.6,5.7,5.7,0,0,0,1.3-2.1,6.4,6.4,0,0,0,.5-2.3,3,3,0,0,0-.5-1.8,1.5,1.5,0,0,0-1.3-.6A4.5,4.5,0,0,0,88.6,209Z"
            transform="translate(-0.9 -1)"
          />
          <path
            d="M98.5,203.3l-5.4,3.1v7.8l5.4-3.2v-1.6l-3.7,2.1v-1.4l3.3-1.9v-1.6l-3.3,1.8V207l3.6-2.1Z"
            transform="translate(-0.9 -1)"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="cls-3"
            d="M288.5,103.7l-23,16.7c-2.9,1.7-9.8-3.1-9.8-6.5V85a11.6,11.6,0,0,1,5.4-9.2l25-14.5c2.9-1.7,10.2,1.8,10.3,4.7l-2.5,28.5A11.4,11.4,0,0,1,288.5,103.7Z"
            transform="translate(-0.9 -1)"
          />
          <path
            class="cls-3"
            d="M257.3,79.8a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.8,6.5l23-16.7a10.5,10.5,0,0,0,3.8-4C281.6,93.5,268.7,85,257.3,79.8Z"
            transform="translate(-0.9 -1)"
          />
          <path
            class="cls-3"
            d="M257.3,79.8a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.8,6.5l23-16.7a10.5,10.5,0,0,0,3.8-4C281.6,93.5,268.7,85,257.3,79.8Z"
            transform="translate(-0.9 -1)"
          />
          <path
            class="cls-3"
            d="M257.3,79.8a10.5,10.5,0,0,0-1.6,5.2v28.9c0,3.4,6.9,8.2,9.8,6.5l23-16.7a10.5,10.5,0,0,0,3.8-4C281.6,93.5,268.7,85,257.3,79.8Z"
            transform="translate(-0.9 -1)"
          />
          <path
            class="cls-4"
            d="M291.4,105.7l-25,14.4c-2.9,1.7-5.3.4-5.3-3V88.2a12,12,0,0,1,5.3-9.3l25-14.4c3-1.7,5.4-.4,5.4,3V96.4A12.1,12.1,0,0,1,291.4,105.7Z"
            transform="translate(-0.9 -1)"
          />
        </g>
        <path
          d="M269.3,91.4v1.2l-.5.3c-.1,0-.2.2-.2.3s-.2.2-.2.5l.2,1.4a2,2,0,0,1-.2,1.1,1.6,1.6,0,0,1-.5.9,2.9,2.9,0,0,1-.8.7l.8-.2a.6.6,0,0,1,.5.2c.2.2.2.5.2,1l-.2,1.7c0,.2,0,.3.2.3s.1.2.3,0l.5-.2v1.2l-1.1.5h-.7l-.4-.3a1.4,1.4,0,0,1,0-.9V99.6c0-.2,0-.5-.1-.6h-.5a.9.9,0,0,0-.7.4V97.8l.7-.5c.3-.1.4-.3.5-.6a1.7,1.7,0,0,0,.1-.7V93.5l.4-.8a1.5,1.5,0,0,1,.7-.7Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M275.6,95.7a2,2,0,0,1,.1-.7l.4-.6c.1-.2.4-.4.5-.5h.5l.3.2a.9.9,0,0,1,.1.5,2.2,2.2,0,0,1-.1.8l-.3.6-.5.4-.5.2-.4-.3A.7.7,0,0,1,275.6,95.7Zm3.7-2.2a2,2,0,0,1,.1-.7l.3-.6.5-.5h.5l.4.2a.9.9,0,0,1,.1.5,2.2,2.2,0,0,1-.1.8l-.4.6c-.1.2-.4.3-.5.5h-.5l-.3-.3C279.3,93.9,279.3,93.8,279.3,93.5Zm3.7-2.1a2.2,2.2,0,0,1,.1-.8,6.1,6.1,0,0,0,.4-.6l.5-.5h.5q.2,0,.3.3c.2.1.2.2.2.4a1.2,1.2,0,0,1-.2.8,3.3,3.3,0,0,1-.3.6l-.5.5h-.5l-.4-.3C283,91.8,283,91.6,283,91.4Z"
          transform="translate(-0.9 -1)"
        />
        <path
          d="M290.4,79.2l1.1-.5h.8c.1,0,.2.2.3.4a1.1,1.1,0,0,1,0,.8v1.6c0,.2,0,.5.1.6h.5a.9.9,0,0,0,.7-.3v1.4c-.2.1-.4.4-.7.5a1.5,1.5,0,0,0-.5.6,2,2,0,0,0-.1.7v2.5l-.3.8a3,3,0,0,1-.8.8l-1.1.7V88.6l.5-.4c.1-.1.3-.2.3-.4s.1-.2.1-.5V85.9a4.1,4.1,0,0,1,.1-1.1,1.6,1.6,0,0,1,.5-.9l.8-.7-.8.3a.6.6,0,0,1-.5-.3,2.5,2.5,0,0,1-.1-1V80.5c0-.2,0-.3-.1-.3s-.2-.1-.3,0l-.5.2Z"
          transform="translate(-0.9 -1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    bookAnim() {
      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#functions",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
        })
        .add("functions")
        .from(
          ".sheet",
          {
            duration: 1,
            scale: 0,
            opacity: 0,
            rotation: 360,
            transformOrigin: "50% 50%",
            stagger: 0.1,
            ease: "sine",
          },
          "functions"
        )
        .from(
          ".bloop",
          {
            duration: 1,
            scale: 0,
            opacity: 0,
            rotation: -360,
            transformOrigin: "50% 50%",
            stagger: 0.1,
            ease: "sine",
          },
          "functions+=0.5"
        );
    },
  },
  mounted() {
    this.bookAnim();
  },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-9 {
  fill: none;
}

.cls-2,
.cls-7 {
  fill: #0e1e25;
}

.cls-3,
.cls-6,
.cls-8 {
  fill: #fff;
}

.cls-3,
.cls-4,
.cls-6,
.cls-7,
.cls-9 {
  stroke: #000;
}

.cls-10,
.cls-3,
.cls-4,
.cls-6,
.cls-7,
.cls-9 {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cls-4 {
  fill: #ffad43;
}

.cls-5 {
  clip-path: url(#clip-path);
}

.cls-6 {
  opacity: 0.3;
  isolation: isolate;
}

.cls-10 {
  stroke: #fff;
}

.cls-11 {
  clip-path: url(#clip-path-2);
}
</style>
